import React,{useEffect, useState} from 'react';
import SimilarProduct from "../SimilarProduct";

function SimilarArtists(props) {

    const [data, setData] = useState([])
    const [isChange, setIsChange] = useState(false)

    useEffect(() => {
        const updatedData = props.data.map(item => ({
            image: item.image,
            name: item.name,
            id: item.id,
        }));
        setData(updatedData);
        setIsChange(true)
    }, [props.data]);

    return (
        <div
            className='basis-full md:basis-2/3 flex flex-col'>
            <div className="flex flex-row items-center text-violet-700 font-black text-base md:text-lg mb-4">
                هنرمندان مرتبط
            </div>
            {isChange && <SimilarProduct data={data} />}
        </div>
    );
}

export default SimilarArtists;